import { Modal } from '@fluentui/react/lib/Modal';
import { mergeClasses } from '@fluentui/react-components';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import { OfficeThemeMode } from '@office-start/theming-types';
import React from 'react';
import { useFirstRunControlStyles } from './FirstRunControl.styles';
import { FirstRunFooter } from './FirstRunFooter';
import { FirstRunGreetings } from './FirstRunGreetings';
import { FirstRunImage } from './FirstRunImage';
import { FirstRunNavButton } from './FirstRunNavButton';
import { FirstRunPromotion } from './FirstRunPromotion';
import { Announcer } from './helpers/Announcer';
import { useFirstRunAriaLabel } from './hooks/useFirstRunAriaLabel';
import { SecondRunDismissButton } from './SecondRunDismissButton';
import { useSecondRunDismissButtonStyles } from './SecondRunDismissButton.styles';
export var FirstRunControl = function (_a) {
    var callbacks = _a.callbacks, config = _a.config, context = _a.context, state = _a.state, themeMode = _a.themeMode, isSecondRun = _a.isSecondRun;
    var styles = useFirstRunControlStyles();
    var secondRunStyles = useSecondRunDismissButtonStyles();
    var slideAriaLabel = useFirstRunAriaLabel({
        ariaLabel: config.ariaLabels.slideAriaLabel,
        idx: state.activeSlideIdx,
        slideGroupLength: state.slideGroupLength,
    });
    var backNavButtonRef = React.useRef(null);
    var nextNavButtonRef = React.useRef(null);
    React.useLayoutEffect(function () {
        callbacks.handleRenderStart(nextNavButtonRef);
    }, []);
    React.useLayoutEffect(function () {
        callbacks.handleSetSlideAnnouncement();
    }, [state.activeSlide, callbacks.handleSetSlideAnnouncement]);
    var containerStyle = React.useMemo(function () {
        return mergeClasses(styles.container, state.isVisible && styles.containerActive);
    }, [styles.container, styles.containerActive, state.isVisible]);
    var firstRunModal = React.useMemo(function () {
        return (
        // TODO: Migrate <Modal /> to <Dialog /> component when it becomes available with Fluent V9 version bump
        React.createElement(Modal, { isOpen: state.isVisible && !state.dimeActive, forceFocusInsideTrap: !state.dimeActive, isDarkOverlay: themeMode !== OfficeThemeMode.dark, styles: {
                main: {
                    'background-color': 'transparent',
                    'box-shadow': 'none',
                },
            } },
            React.createElement(OfficeFluentProvider, { className: styles.fluentProvider },
                React.createElement(Announcer, { isEnabled: state.slideAnnouncmentEnabled, text: state.slideAnnouncement }),
                React.createElement("div", { className: containerStyle },
                    React.createElement(FirstRunNavButton, { id: "first-run-arrow-lt", config: config, action: "back", clickAction: function () {
                            callbacks.handleBackNavButtonClick(backNavButtonRef, nextNavButtonRef);
                        }, hidden: state.isGreetingsActive ||
                            state.activeSlideIdx === 0, ref: backNavButtonRef }),
                    React.createElement("div", { className: styles.content, role: "group", "aria-roledescription": "slide", "aria-label": slideAriaLabel, "data-testid": "first-run-modal" },
                        React.createElement("div", { className: styles.header }, isSecondRun ? (React.createElement("span", { className: secondRunStyles.position },
                            React.createElement(SecondRunDismissButton, { action: "dismiss", id: "sre-dismiss-button", clickAction: callbacks.onDismissClick }))) : (React.createElement(FirstRunImage, { imgConfig: config.icons.m365Icon, className: styles.image, themeMode: themeMode, context: context }))),
                        React.createElement("div", { className: styles.slideContent },
                            React.createElement(FirstRunGreetings, { config: config, active: state.isGreetingsActive, setIsGreetingsActive: callbacks.handleDisableGreetings, themeMode: themeMode, context: context }),
                            React.createElement(FirstRunPromotion, { slideGroup: config.slideGroups[state.activeSlideGroupIdx], active: !state.isGreetingsActive, activeSlideIdx: state.activeSlideIdx, themeMode: themeMode, context: context, callbacks: callbacks })),
                        React.createElement(FirstRunFooter, { activeSlideIdx: state.activeSlideIdx, slideGroup: config.slideGroups[state.activeSlideGroupIdx], active: !state.isGreetingsActive, config: config })),
                    React.createElement(FirstRunNavButton, { id: "first-run-arrow-rt", config: config, action: state.activeSlideIdx ===
                            state.slideGroupLength - 1
                            ? 'complete'
                            : 'next', clickAction: callbacks.handleNextNavButtonClick, hidden: state.isGreetingsActive, ref: nextNavButtonRef })))));
    }, [
        state.isVisible,
        state.dimeActive,
        state.slideAnnouncmentEnabled,
        state.slideAnnouncement,
        state.isGreetingsActive,
        state.activeSlideIdx,
        state.activeSlideGroupIdx,
        state.slideGroupLength,
        themeMode,
        styles.fluentProvider,
        styles.content,
        styles.header,
        styles.image,
        styles.slideContent,
        containerStyle,
        config,
        slideAriaLabel,
        isSecondRun,
        secondRunStyles.position,
        callbacks,
        context,
    ]);
    return firstRunModal;
};
//# sourceMappingURL=FirstRunControl.js.map